import React, { Component, Fragment } from 'react';

class Card extends Component {

    
    render() {
        return (
            <Fragment>
                <div className="card">
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item active text-center">{this.props.titulo}</li>
                        <li className="list-group-item">
                            <span className="fs-2em">{this.props.total}</span>
                        </li>
                    </ul>
                </div>
            </Fragment>
        );
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/servers/Card.js